import React from "react";
import {
  Paper,
  Typography,
} from "@material-ui/core";
import classnames from "classnames";

// styles
import useStyles from "./styles";

export default function Widget({
  children,
  title,
  noBodyPadding,
  bodyClass,
  disableWidgetMenu,
  header,
  ...props
}) {
  var classes = useStyles();

  return (
    <div className={classes.widgetWrapper}>
      <Paper className={classes.paper} classes={{ root: classes.widgetRoot }}>
          {!header ? (
            header
          ) : (
            <div className={classes.widgetHeader}>
              <React.Fragment>
                <Typography variant="h5" color="textSecondary">
                  {title}
                </Typography>
              </React.Fragment>
            </div>
          )}
        <div
          className={classnames(classes.widgetBody, {
            [classes.noPadding]: noBodyPadding,
            [bodyClass]: bodyClass,
          })}
        >
          {children}
        </div>
      </Paper>
     </div>
  );
}
